import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-country-state-city/dist/react-country-state-city.css';
import 'src/content/applications/Settings/datepage.css';
import 'src/User-Details/Users/deletepopup.css';
import 'src/components/TextField/ToggleableDateField.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { store } from './store/store';

// Fix ResizeObserver loop error that occurs during browser resizing
const resizeObserverPatch = () => {
  // Patch ResizeObserver constructor
  const originalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class extends originalResizeObserver {
    constructor(callback) {
      const wrappedCallback = (entries, observer) => {
        // Use setTimeout to break the synchronous loop
        requestAnimationFrame(() => {
          try {
            return callback(entries, observer);
          } catch (error) {
            if (
              error.message === 'ResizeObserver loop completed with undelivered notifications.' ||
              error.message === 'ResizeObserver loop limit exceeded' ||
              error.message?.includes?.('ResizeObserver loop')
            ) {
              // Suppress the error silently
              return;
            }
            throw error;
          }
        });
      };

      super(wrappedCallback);
    }
  };

  // Patch console.error to suppress ResizeObserver errors
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0];
    if (
      typeof message === 'string' &&
      (message.includes('ResizeObserver loop completed with undelivered notifications') ||
        message.includes('ResizeObserver loop limit exceeded') ||
        message.includes('ResizeObserver'))
    ) {
      return; // Suppress ResizeObserver errors
    }
    originalConsoleError.apply(console, args);
  };

  // Also suppress unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes('ResizeObserver')) {
      e.preventDefault();
      return;
    }
  });

  // And regular error events
  window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver')) {
      e.preventDefault();
      return;
    }
  });
};

resizeObserverPatch();

ReactDOM.render(
  <HelmetProvider>
    <SidebarProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {/* Here we are using client id hardcoded for testing purpose */}
        <GoogleOAuthProvider clientId="223996794975-m0ondtdav8ufmeh6g32nrf2et4t2nf4q.apps.googleusercontent.com">
          <Provider store={store}>
            <App />
          </Provider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </SidebarProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
